<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Out of My Later Years</title>
<link href="default.css" rel="stylesheet" type="text/css"/>
<p class="ct"><a href="#/contents#tahir0006" id="tahir006">5</a></p>
<p class="ct1"><a href="#/contents#tahir0006">Message For Posterity</a></p>
<p class="tx1">OUR TIME IS RICH in inventive minds, the inventions of which could facilitate our lives considerably. We are crossing the seas by power and utilize power also in order to relieve humanity from all tiring muscular work. We have learned to fly and we are able to send messages and news without any difficulty over the entire world through electric waves.</p>
<p class="tx">However, the production and distribution of commodities is entirely unorganized so that everybody must live in fear of being eliminated from the economic cycle, in this way suffering for the want of everything. Furthermore, people living in different countries kill each other at irregular time intervals, so that also for this reason any one who thinks about the future must live in fear and terror. This is due to the fact that the intelligence and the character of the masses are incomparably lower than the intelligence and character of the few who produce something valuable for the community.</p>
<p class="tx">I trust that posterity will read these statements with a feeling of proud and justified superiority.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?05ad8107